import { makeObservable, observable } from "mobx"
import { nanoid } from "nanoid"
import { ValueStore } from "pages/content/store"

class Content {

  id: string
  name: string = ""
  schemeId: string
  ignoreBlocks: string[] = []
  data: { sectionId: string, slugPrefix: string, values: ValueStore } = { values: {}, sectionId: "", slugPrefix: "landings.v2" }

  constructor(schemeId: string, id?: string) {
    this.id = id || nanoid(4)
    this.schemeId = schemeId
    makeObservable(this, {
      name: observable,
      schemeId: observable
    })
  }

  save() {
    return {
      id: this.id,
      name: this.name,
      schemeId: this.schemeId,
      ignoreBlocks: this.ignoreBlocks?.length > 0? this.ignoreBlocks: undefined,
      data: JSON.parse(JSON.stringify(this.data))
    }
  }

}

export default Content